import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { DataMainTemplate } from "@nocios/presentation-kit";
import Config from "src/Constants/Config";
import setCurrentPage from "src/Utils/setCurrentPage";
import Subtitle from "./Subtitle";
import AnimtionLeftPanelBlue from "src/Component/AnimtionLeftPanelBlue";

// Constants
const PAGE_ID = 8;
const BG_ID = 8;
const BG_TYPE = "jpg";
const NEXT_PAGE_ID = PAGE_ID + 1;
const BACK_PAGE_ID = PAGE_ID - 1;
// const LAST_PAGE = false;

const LEFT_TITLE = "Insights driven Operational\nEfficiency";

// Main data function that returns the template data
const DATA = (): DataMainTemplate => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const currentPage = useSelector((state: { appReducer: { currentPage: number } }) => state.appReducer.currentPage);

  const baseImageBG = `${Config.BASE_URL}/images/BG/`;

  const backButton =
    BACK_PAGE_ID > 0
      ? {
          label: "Back",
          type: "back" as const,
          startIcon: { icon: "arrow-right", color: "#fff" },
          onClick: () => setCurrentPage(BACK_PAGE_ID),
          style: {
            borderRadius: "45px",
            padding: "var(--width-5) var(--width-25)",
            gap: "var(--width-16)",
          },
        }
      : undefined;

  const nextButton = {
    label: "Next",
    type: "next" as const,
    endIcon: { icon: "arrow-left" },
    onClick: () => setCurrentPage(NEXT_PAGE_ID),
    style: {
      borderRadius: "45px",
      padding: "var(--width-5) var(--width-25)",
      gap: "var(--width-16)",
    },
  };

  const [startAnimation, setStartAnimation] = useState(false);

  useEffect(() => {
    let timer: NodeJS.Timeout;
    if (PAGE_ID === currentPage) {
      if (videoRef.current) videoRef.current.play();

      timer = setTimeout(() => {
        setStartAnimation(true);
      }, 100);
    } else {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }

      setStartAnimation(false);
    }

    return () => clearTimeout(timer);
  }, [currentPage]);

  return {
    styleBody: { marginTop: 0 },
    bgImage: `${baseImageBG}BG_${BG_ID}.${BG_TYPE}`,
    title: LEFT_TITLE,
    leftAfterTitle: <Subtitle text={"Unified Command Center providing single pane of\nglass for on time strategic interventions."} />,
    description:
      '<ul id="ilo-ul-screen-8"><li>Duration predictability</li><li>Outcome predictability</li><li>Fault predictability</li><li>Demand predictability</li><li>NW topology RCA</li><li>Data driven prioritization</li><li>Service Impact Assessment</li></ul>',
    leftAfterDescription: (
      <AnimtionLeftPanelBlue
        style={{ left: "calc(-1 * var(--width-101))", width: "var(--width-792)", top: "var(--height-20)" }}
        startAnimation={startAnimation}
        image={`${Config.BASE_URL}/images/screen_${PAGE_ID}/left_0.png`}
      />
    ),
    rightSideComponent: (
      <>
        <div
          style={{
            right: "var(--width-16)",
            bottom: "var(--height-235)",
            position: "absolute",
            width: "var(--width-825)",
            height: "var(--height-430)",
            overflow: "hidden",
            zIndex: 10,
          }}
        >
          <video
            ref={videoRef}
            style={{
              width: "100%",
              height: "100%",
              zIndex: 20,
              transformOrigin: "center",
              objectFit: "contain",
            }}
            src={`${Config.BASE_URL}/videos/screen_8.mp4`}
            muted
            controls
          />
        </div>
      </>
    ),
    next: nextButton,
    back: backButton,
  };
};

export default DATA;
